import { useQuery } from 'react-query';

import { announcementApi } from 'src/Services/API';

const useActiveAnnouncement = () => {
  return useQuery({
    queryKey: ['active-announcement'],
    queryFn: () => announcementApi.findActive(),
    staleTime: 2 * 60 * 1000,
    cacheTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchInterval: 3 * 60 * 1000,
  });
};

export default useActiveAnnouncement;
